import React, { useEffect, useState } from 'react';
import SoilDoctorLogo from '../assets/Images/SoilDoctorLogo.png';
import { getPartnerLogoPresentation, usePartnerLogoAspect } from '../utils/partnerLogoDisplay';

/**
 * AppLogo — partner logo layout auto-detected from image aspect ratio.
 */
const AppLogo = ({
  partnerLogoUrl,
  alt = 'Soil Doctor Logo',
  className = '',
  style = {},
}) => {
  const isPartnerLogo = Boolean(partnerLogoUrl);
  const [src, setSrc] = useState(partnerLogoUrl || SoilDoctorLogo);

  useEffect(() => {
    setSrc(partnerLogoUrl || SoilDoctorLogo);
  }, [partnerLogoUrl]);

  const { isBanner, onImageLoad } = usePartnerLogoAspect(isPartnerLogo ? partnerLogoUrl : null);

  const handleError = () => {
    if (src !== SoilDoctorLogo) {
      setSrc(SoilDoctorLogo);
    }
  };

  const presentation = getPartnerLogoPresentation(isPartnerLogo && isBanner, 'navbar');

  return (
    <img
      src={src}
      alt={alt}
      onLoad={onImageLoad}
      onError={handleError}
      className={[presentation.className, className].filter(Boolean).join(' ')}
      style={{ ...presentation.style, ...style }}
    />
  );
};

export default AppLogo;
